import {
	OPEN_COPY_FILTER_MODAL,
	CLOSE_COPY_FILTER_MODAL,
	type Action,
} from '../../actions/copy-filter-modal';
import type { CopyFilterModalState } from './types';

export const initialState: CopyFilterModalState = {
	isCopyFilterModalOpen: false,
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	state: CopyFilterModalState = initialState,
	action: Action,
): CopyFilterModalState => {
	switch (action.type) {
		case OPEN_COPY_FILTER_MODAL: {
			return {
				isCopyFilterModalOpen: true,
			};
		}

		case CLOSE_COPY_FILTER_MODAL: {
			return {
				isCopyFilterModalOpen: false,
			};
		}
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
